import { useEffect, useState } from 'react';

export type ProgramSkillMapping = {
  program_id: string;
  skill_id: string;
};

const MAPPINGS_URL = 'https://s3.us-east-1.amazonaws.com/coursera_assets/assess/program-pinned-skills-mappings.json';

export const useProgramPinnedSkills = (programId: string) => {
  const [loading, setLoading] = useState(true);
  const [pinnedSkills, setPinnedSkills] = useState<string[]>([]);

  useEffect(() => {
    setLoading(true);
    fetch(MAPPINGS_URL)
      .then((response) => response.json())
      .then((mappings: ProgramSkillMapping[]) => {
        const programPinnedSkills = mappings
          .filter((mapping) => mapping.program_id === programId)
          .map((mapping) => mapping.skill_id);
        setPinnedSkills(programPinnedSkills);
        setLoading(false);
      });
  }, [programId]);

  return { loading, pinnedSkills };
};
